import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { Box, Typography, Button, Modal, TextField, IconButton, CircularProgress } from '@mui/material';

export default function SendTestEmailModal({ open, onClose, onSend, templateName = '', loading = false, initialEmail = '' }) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setEmail(initialEmail || '');
            setError('');
        }
    }, [open, initialEmail]);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const handleSend = () => {
        if (!email.trim()) {
            setError('Recipient email is required');
            return;
        }
        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }
        onSend(email);
    };

    return (
        <Modal open={open} onClose={loading ? null : onClose}>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: 400 }, bgcolor: 'background.paper', borderRadius: 3, p: 4, boxShadow: 24,
                display: 'flex', flexDirection: 'column', gap: 2
            }}>
                <IconButton 
                    sx={{ position: 'absolute', top: 12, right: 12 }} 
                    onClick={onClose}
                    disabled={loading}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h6" fontWeight="bold">
                    Send Test Email
                </Typography>
                
                <Typography variant="body2" color="text.secondary">
                    Sending a test for template: <b>{templateName}</b>
                </Typography>

                <TextField
                    fullWidth
                    label="Recipient Email Address"
                    placeholder="e.g. admin@example.com"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        if (error) setError('');
                    }}
                    error={!!error}
                    helperText={error}
                    disabled={loading}
                    autoFocus
                />

                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                    <Button 
                        fullWidth 
                        variant="outlined" 
                        onClick={onClose} 
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button 
                        fullWidth 
                        variant="contained" 
                        onClick={handleSend} 
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                    >
                        {loading ? 'Sending...' : 'Send Test'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
